import React from "react";

import DesktopNav from "./desktop-nav";
import MobileNav from "./mobile-nav";
import Notification from "./notification";
import data from '../data/data'
import "../styles/nav-bar.scss";

const NavBar = props => {
  return (
    <header>
      <div className="nav-bar-container">
        <MobileNav toggleDrawer={props.toggleDrawer}/>
        <DesktopNav />
        {data.notification.showNotification && <Notification />}
      </div>
    </header>
  );
};

export default NavBar;
